<template>
  <div class="recharge-activity-page">
    <div class="recharge-activity">商圈联盟</div>
    <el-button type="primary" @click="dialogVisible = true" class="mt20"
      >添加券</el-button
    >
    <div class="table-area">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          align="center"
          prop="shopName"
          label="商户名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="shopMobile"
          label="商户ID"
        ></el-table-column>
        <el-table-column align="center" prop="title" label="优惠券"></el-table-column>
        <el-table-column align="center" prop="orderStatus" label="状态">
          <template slot-scope="scope">
            <div>
              <!-- {{
              scope.row.orderStatus == 1
              ? "未使用"
              : scope.row.orderStatus == 2
              ? "正常"
              : scope.row.orderStatus == 3
              ? "领完"
              : scope.row.orderStatus == 4
              ? "停用"
              : ""
              }} -->
              {{ scope.row.orderStatus }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="有效期" width="400">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime }} 至 {{ scope.row.expireDay }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteMerchant(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        class="block"
        style="float: right; margin-top: 10px"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加联盟商户"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <span>
        <div class="flex-row-starts">
          <el-input
            v-model="shopMobile"
            placeholder="输入商户ID（手机号码）"
            style="width: 400px; margin-right: 20px"
          ></el-input>
          <el-button type="primary" @click="search">搜索</el-button>
        </div>
        <div class="tips" v-show="isTips">{{ tips }}</div>
        <div class="merChant-shopName">商户名称：{{ merChant }}</div>
        <el-table :data="allianceData" style="width: 100%" :max-height="500">
          <el-table-column prop="title" label="优惠券信息" width="180" />
          <el-table-column prop="createTime" label="有效期" width="195">
            <template slot-scope="scope"
              >{{ scope.row.createTime }} 至 {{ scope.row.expireDay }}</template
            >
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="addToShopCouponUnion(scope.row)"
                >添加到我的商圈</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="
            (dialogVisible = false),
              (shopMobile = ''),
              (merChant = ''),
              (allianceData = []),
              (isTips = false)
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCashCouponUnionList,
  deleteToShopCouponUnion,
  getAddShopCouponUnionList,
  addToShopCouponUnion,
} from "@/api/index";
export default {
  data() {
    return {
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      loading: false,
      dialogVisible: false,
      tips: "",
      shopMobile: "",
      isTips: false,
      merChant: "",
      allianceData: [],
      orderStatus: "",
    };
  },
  created() {
    this.getCashCouponUnionList();
  },
  methods: {
    getCashCouponUnionList(startDate, endDate) {
      this.loading = true;
      getCashCouponUnionList({
        pageNumber: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        startDate: startDate,
        endDate: endDate,
      }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.total = res.data.totalCount;
          var timestamp = Date.parse(new Date());
          for (var i in this.tableData) {
            var time3 = Date.parse(this.tableData[i].expireDay);
            if (timestamp - time3 > 86400) {
              this.tableData[i].orderStatus = "过期";
            } else {
              this.tableData[i].orderStatus =
                this.tableData[i].orderStatus == 1
                  ? "未使用"
                  : this.tableData[i].orderStatus == 2
                  ? "已发布"
                  : this.tableData[i].orderStatus == 3
                  ? "已用完"
                  : this.tableData[i].orderStatus == 4
                  ? "商家停止发放"
                  : this.tableData[i].orderStatus == 100
                  ? "审核中"
                  : this.tableData[i].orderStatus == 101
                  ? "审核失败"
                  : "";
            }
          }
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getCashCouponUnionList();
    },
    deleteMerchant(row) {
      this.$confirm("此操作将删除该优惠券, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        deleteToShopCouponUnion({
          cashCouponUnionId: row.cashCouponUnionId,
        })
          .then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getCashCouponUnionList();
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "取消输入"
            // });
          });
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.shopMobile = "";
      this.tips = "";
      this.isTips = false;
      this.allianceData = [];
      this.merChant = "";
    },
    search() {
      getAddShopCouponUnionList({
        shopMobile: this.shopMobile,
      }).then((res) => {
        this.isTips = true;
        this.tips = res.msg;
        if (res.code == 1) {
          this.tips = "该商户可以添加为您的联盟商户";
          this.merChant = res.data.shop.shopName;
          this.allianceData = res.data.cashCouponBatchOrders;
        } else if (res.code == -1) {
          this.allianceData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.allianceData = [];
          this.merChant = "";
          this.shopMobile = "";
        }
      });
    },
    addToShopCouponUnion(row) {
      addToShopCouponUnion({
        shopMobile: this.shopMobile,
        cashCouponBatchOrderId: row.id,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.getCashCouponUnionList();
        } else if (res.code == -1) {
          this.allianceData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mt20 {
  margin-top: 20px;
}
.flex-row-starts {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.tips {
  width: 90%;
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  box-sizing: border-box;
  border: 1px solid #ff9191;
  background: #ffe6e6;
  color: #ff7757;
  font-size: 12px;
  margin-top: 20px;
}
.merChant-shopName {
  font-weight: bold;
  padding: 15px 0;
  box-sizing: border-box;
}
.recharge-activity-page {
  padding: 30px 20px 20px 30px;
  box-sizing: border-box;
  height: calc(100% - 80px);
  overflow-y: scroll;
  .recharge-activity {
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    box-sizing: border-box;
  }
  .flex-row-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 25px 0;
    box-sizing: border-box;
    .activity-name {
      padding-right: 10px;
      box-sizing: border-box;
      line-height: 40px;
    }
    .bold {
      font-weight: bold;
      .color-orange {
        color: #ff7757;
        cursor: pointer;
      }
    }
  }
  .table-area {
    padding-top: 25px;
    box-sizing: border-box;
  }
}
/deep/ .el-table th {
  background-color: #f7f8fa;
}
</style>
